import React, { useCallback } from 'react';
import { FilePicker } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

function File({
    placeholder,
    activePlaceholder,
    limit,
    maxSize,
    fileTypes,
    value = [],
    onChange,
    handleDownload,
    ...props
}) {
    const { t } = useWeb5Context();

    const onDrop = useCallback(
        (acceptedFiles) => {
            const finalValue = value || [];
            onChange && onChange([...finalValue, ...acceptedFiles]);
        },
        [onChange, value],
    );

    const onRemove = useCallback(
        (deletedFile) => {
            onChange &&
                onChange(
                    value.filter(
                        (file) =>
                            !(
                                file.name === deletedFile.name &&
                                file.size === deletedFile.size &&
                                file.type === deletedFile.type
                            ),
                    ),
                );
        },
        [onChange, value],
    );

    return (
        <FilePicker
            title={placeholder || t('cfm_label_drag_and_drop_and_upload')}
            activePlaceholder={activePlaceholder || t('cfm_label_drop_to_upload')}
            onDrop={onDrop}
            onRemove={onRemove}
            files={value || []}
            maxFiles={limit}
            maxSize={maxSize}
            accept={fileTypes}
            isFullWidth={true}
            handleDownload={handleDownload}
            {...props}
        />
    );
}

File.propTypes = {};

export default React.memo(File);
